
import { defineComponent, ref, watch } from 'vue';
import BaseLayout from '@/layouts/BaseLayout.vue';
import HeaderBar from '@/components/common/HeaderBar.vue';
import BusInfoCard from '@/components/common/BusInfoCard.vue';
import busHandler from '@/api-handler/bus';
import { useRoute } from 'vue-router';
import { IBusRoute } from '@/types/api/bus';
import { taiwanCity } from '@/utils/cities';
import { City } from '@/types/common';
import LoadingPage from '@/components/common/LoadingPage.vue';


export default defineComponent({
  name: 'FindBusStaion',
  components: {
    BaseLayout,
    HeaderBar,
    BusInfoCard,
    LoadingPage,
  },
  setup() {
    const cityList = taiwanCity;
    const route = useRoute();
    const busRoutes = ref<IBusRoute[]>([]);
    const currentCity = ref<string>('');
    const searchInput = ref<string>('');
    const { city } = route.params;
    const isLoading = ref<boolean>(true);
    const getOneCityAllBusRoute = async(city: string) => {
      try {
        isLoading.value = true;
        const res = await busHandler.getOneCityAllBusRouteInfo(city);
        if (res) {
          busRoutes.value = res.data;
          isLoading.value = false;
        }
      } catch (error) {
        console.log(error);
        isLoading.value = false;
      }
    };
    const getCurrentCity = (cityEnglishName: string) => {
      cityList.forEach((city: City) => {
        if (cityEnglishName === city.value) {
          currentCity.value = city.name;
        }
      });
    };
    const keyInMiniKeyboard = (word: string) => {
      searchInput.value += word;
    };
    const clearInput = () => {
      searchInput.value = '';
    };
    const filterBusRoute = () => {
      busRoutes.value = busRoutes.value.filter((route) => route.RouteName?.Zh_tw.includes(searchInput.value));
    };
    watch(() => searchInput.value, (v: string) => {
      if (v !== '') {
        filterBusRoute();
      } else {
        getOneCityAllBusRoute(city as string);
      }

    })
    return {
      getOneCityAllBusRoute,
      getCurrentCity,
      keyInMiniKeyboard,
      clearInput,
      filterBusRoute,
      busRoutes,
      currentCity,
      searchInput,
      city,
      isLoading,
    }
  },
  created() {
    this.getOneCityAllBusRoute(this.city as string);
    this.getCurrentCity(this.city as string);
  }
});
